import { render } from "./ourStory.vue?vue&type=template&id=7ef80611&scoped=true"
import script from "./ourStory.vue?vue&type=script&lang=js"
export * from "./ourStory.vue?vue&type=script&lang=js"

import "./ourStory.vue?vue&type=style&index=0&id=7ef80611&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef80611"]])

export default __exports__